export const PRODUCT_FILTERS = [
  {
    key: "brand",
    label: "Brand",
    defaultOptions: ["YCH-YOYO"],
  },
  {
    key: "type",
    label: "Yo-Yo Type",
    defaultOptions: [
      "Two-Hand Looping",
      "Yo-Yo Parts",
      "Offstring",
      "Freehand",
      "Single-Hand String",
      "Two-Hand String",
    ],
  },
  {
    key: "group",
    label: "Division",
    defaultOptions: ["1A", "2A", "3A", "4A", "5A"],
  },
];

export const DEFAULT_PRODUCT_TAGS = {
  1: { brand: ["YCH-YOYO"], type: ["Two-Hand Looping"], group: ["2A"] },
  2: { brand: ["YCH-YOYO"], type: ["Two-Hand Looping"], group: ["2A"] },
  3: { brand: ["YCH-YOYO"], type: ["Two-Hand Looping"], group: ["2A"] },
  4: { brand: ["YCH-YOYO"], type: ["Two-Hand Looping"], group: ["2A"] },
  5: { brand: ["YCH-YOYO"], type: ["Two-Hand Looping"], group: ["2A"] },
  6: { brand: ["YCH-YOYO"], type: ["Two-Hand Looping"], group: ["2A"] },
  7: { brand: ["YCH-YOYO"], type: ["Two-Hand Looping"], group: ["2A"] },
  8: { brand: ["YCH-YOYO"], type: ["Two-Hand Looping"], group: ["2A"] },
  9: { brand: ["YCH-YOYO"], type: ["Two-Hand Looping"], group: ["2A"] },
  10: { brand: ["YCH-YOYO"], type: ["Yo-Yo Parts"], group: [] },
  11: { brand: ["YCH-YOYO"], type: ["Yo-Yo Parts"], group: [] },
  12: { brand: ["YCH-YOYO"], type: ["Yo-Yo Parts"], group: [] },
  13: { brand: ["YCH-YOYO"], type: ["Yo-Yo Parts"], group: [] },
};

const TAG_ALIASES = {
  "双手回旋": "Two-Hand Looping",
  "悠悠球零件": "Yo-Yo Parts",
  "悠悠球配件": "Yo-Yo Parts",
  "零件": "Yo-Yo Parts",
  "配件": "Yo-Yo Parts",
  "离线": "Offstring",
  "离手": "Freehand",
  "单手线上": "Single-Hand String",
  "双手线上": "Two-Hand String",
};

const unique = (values) => Array.from(new Set(values.filter(Boolean)));

const normalizeTagValue = (value) => {
  const trimmed = String(value || "").trim();
  return TAG_ALIASES[trimmed] || trimmed;
};

export const normalizeTagValues = (values) => (
  unique((Array.isArray(values) ? values : [values]).map(normalizeTagValue))
);

const toTagValues = (value) => {
  if (Array.isArray(value)) {
    return normalizeTagValues(value);
  }
  if (value === undefined || value === null || value === "") {
    return [];
  }
  return normalizeTagValues(value);
};

export const getProductTags = (product = {}) => {
  const fallback = DEFAULT_PRODUCT_TAGS[product.id] || { brand: ["YCH-YOYO"], type: [], group: [] };
  const rawTags = product.tags || {};

  return PRODUCT_FILTERS.reduce((tags, filter) => {
    const hasExplicitValue = (
      Object.prototype.hasOwnProperty.call(rawTags, filter.key)
      || Object.prototype.hasOwnProperty.call(product, filter.key)
    );
    const explicitValue = rawTags[filter.key] ?? product[filter.key];
    const values = toTagValues(explicitValue);
    tags[filter.key] = hasExplicitValue ? values : toTagValues(fallback[filter.key]);
    return tags;
  }, {});
};

export const withProductTags = (product) => ({
  ...product,
  tags: getProductTags(product),
});

export const buildFilterSections = (products) => (
  PRODUCT_FILTERS.map((filter) => {
    const dynamicOptions = products.flatMap((product) => getProductTags(product)[filter.key] || []);
    const options = unique([...filter.defaultOptions, ...dynamicOptions]).map((value) => ({
      value,
      count: products.filter((product) => getProductTags(product)[filter.key]?.includes(value)).length,
    }));

    return {
      ...filter,
      options,
    };
  })
);

export const productMatchesFilters = (product, selectedFilters) => {
  const tags = getProductTags(product);

  return PRODUCT_FILTERS.every((filter) => {
    const selectedValues = selectedFilters[filter.key] || [];
    if (!selectedValues.length) {
      return true;
    }
    return selectedValues.some((value) => tags[filter.key]?.includes(value));
  });
};
